module.exports = __webpack_public_path__ + "img/bg.ddba3084.png";